import React from "react";
import VirtualSelectorSearchDialog from "./VirtualSelectorSearchDialog";
import { SearchItem } from "./utils";
import { VirtualSelectorStore } from "./VirtualSelectorStore";

type Props<SEARCH_ITEM extends SearchItem> = {
  renderControl: () => React.ReactNode;
  renderFilter: () => React.ReactNode;
  renderItem: (data: SEARCH_ITEM, selected: boolean) => React.ReactNode;
  onShowSelected?: () => void;
  store: VirtualSelectorStore<any, SEARCH_ITEM, any>;
  waitingContent?: React.ReactNode;
};

class VirtualSelector<SEARCH_ITEM extends SearchItem> extends React.Component<
  Props<SEARCH_ITEM>
> {
  renderDialog = () => {
    return (
      <VirtualSelectorSearchDialog
        renderItem={this.props.renderItem}
        onShowSelected={this.props.onShowSelected}
        renderFilter={this.props.renderFilter}
        store={this.props.store}
        waitingContent={this.props.waitingContent}
      />
    );
  };

  render() {
    return (
      <>
        {this.props.renderControl()}
        {this.renderDialog()}
      </>
    );
  }
}

export default VirtualSelector;
